<template>
    <div>
        <el-card class="card">
            <el-col :span="24" class="block">
                <div class="demo-input-suffix mar-t-5f">
                    <el-row>
                        <el-col :span="8" class="room-search">
                            <span class="pad-l-20 mar-r-5">所属楼宇</span>
                            <el-select v-model="formInline.building_id" @change="getFloors" clearable size="small"
                                placeholder="请选择">
                                <el-option v-for="(item, index) in buildList" :key="index" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8" class="room-search">
                            <span class="pad-l-20 mar-r-5">所属楼层</span>
                            <el-select v-model="formInline.floor_id" clearable size="small" placeholder="请选择">
                                <el-option v-for="(item, index) in floorLists" :key="index" :label="item.code"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8" class="room-search">
                            <span class="pad-l-20">房间号</span>
                            <el-input size="small" placeholder="请输入要查询的房间号" class="configInput"
                                v-model="formInline.name">
                            </el-input>
                        </el-col>
                        <el-col :span="8" class="room-search">
                            <span class="pad-l-20 mar-r-5">出租状态</span>
                            <el-select v-model="formInline.status" clearable size="small" placeholder="请选择">
                                <el-option v-for="(item, index) in roomStatuss" :key="index" :label="item.name"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8" class="room-search">
                            <span class="pad-l-20 mar-r-5">虚拟房间</span>
                            <el-select v-model="formInline.is_invented" clearable size="small" placeholder="请选择">
                                <el-option label="是" :value="1"> </el-option>
                                <el-option label="否" :value="0"> </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8" class="room-search">

                            <el-button size="small" class="mar-l-20" :loading="btnLoding" type="primary"
                                @click="search">搜索</el-button>
                            <el-button class="mar-l-5" @click="
                                formInline = {};
                            onLoad();
                            " size="small">重置</el-button>
                            <el-button class="mar-l-5" icon="el-icon-download" :loading="downLoading"
                                @click="getMetaCommonListExport" size="small">导出</el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-card>
        <avue-crud :option="option" :table-loading="loading" :data="data" ref="crud" :page.sync="page"
            @refresh-change="refreshChange" @on-load="onLoad">
            <template slot-scope="scope" slot="menu">

            </template>
        </avue-crud>
    </div>
</template>

<script>
import roomInfo from './../../build/space/roomInfo';
import * as dictbizService from '@/api/system/dictbiz';
import splitRoom from './../../build/space/splitRoom';

import {
    getMetaCommonList,
    updateMetaCommon,
    getMetaCommonListExport,
} from '@/api/busiMode/metaCommon';
import { updateRoomStatus } from '@/api/build'

export default {
    components: { roomInfo, splitRoom },
    data() {
        return {
            formInline: {},
            detailDia: false,
            dialogVisible: false,
            updateDialog: false,
            title: '',
            btnLoding: false,
            downLoading: false,
            page: {
                size: 10,
                current: 1,
                total: 0,
            },
            tableLoading: false,
            model: 'wisdom_park.wp_room',
            view_model: 'wisdom_park.v_wp_room_info',
            floorModel: 'wisdom_park.wp_floor',
            room_export: 'wisdom_park.v_wp_room_export_stat',

            spaces: [],
            floors: [],
            ruleForm: { label: [] },
            currentIndex: '',
            onlyRead: false,
            roomTitle: '新增房间',
            sumCheckinArea: '',
            loading: false,
            searchText: '',
            data: [],
            buildRead: false,
            roomStatuss: [],
            option: {
                align: 'center',
                calcHeight: 30,
                dialogWidth: 900,
                tip: false,
                searchShow: true,
                searchMenuSpan: 6,
                border: true,
                index: true,
                // selection: true,
                labelWidth: 120,
                menu: false,
                menuWidth: 80,
                viewBtn: false,
                dialogClickModal: false,
                delBtn: false,
                editBtn: false,
                addBtn: false,
                cancelBtn: false,
                column: [
                    {
                        overHidden: true,
                        align: 'left',
                        label: '名称',
                        prop: 'name',
                        hide: false,
                    },
                    {
                        overHidden: true,
                        align: 'left',
                        label: '楼宇名称',
                        prop: 'building_name',
                        hide: false,
                    },

                    {
                        width: 80,
                        overHidden: true,
                        label: '楼层',
                        prop: 'floor_code',
                    },

                    {
                        width: 110,
                        overHidden: true,
                        label: '房间面积(m²)',
                        align: 'right',
                        prop: 'room_area',
                    },
                    {
                        width: 100,
                        overHidden: true,
                        label: '出租状态',
                        prop: 'status',
                        dicData: [
                            {
                                value: 0,
                                label: '未出租',
                            },
                            {
                                value: 1,
                                label: '已出租',
                            },
                            {
                                value: 2,
                                label: '已售',
                            },
                            {
                                value: 3,
                                label: '自用',
                            },
                        ],
                    },
                    {
                        width: 100,
                        overHidden: true,
                        label: '是否展示',
                        prop: 'internet_show_flag',
                        dicData: [
                            {
                                value: 0,
                                label: '不展示',
                            },
                            {
                                value: 1,
                                label: '展示',
                            }
                        ],
                    },
                    {
                        width: 100,
                        overHidden: true,
                        label: '虚拟房间',
                        align: 'center',
                        prop: 'is_invented',
                        dicData: [
                            {
                                value: 0,
                                label: '否',
                            },
                            {
                                value: 1,
                                label: '是',
                            },
                        ],
                    },
                    {
                        width: 100,
                        overHidden: true,
                        label: '是否拥有产权',
                        align: 'center',
                        prop: 'has_ownership',
                        dicData: [
                            {
                                value: 0,
                                label: '否',
                            },
                            {
                                value: 1,
                                label: '是',
                            },
                        ],
                    },
                    {
                        overHidden: true,
                        label: '入驻企业',
                        prop: 'company_name',
                        hide: false,
                        width: 140
                    }
                ],
            },
            buildList: [],
            floorList: [],
            floorLists: [],
        };
    },
    props: {
        status: {
            type: String | Number,
            default: ''
        }
    },
    watch: {
        status: {
            handler(val) {
                if (val) {
                    this.formInline.status = val
                }
            },
            immediate: true
        }
    },
    mounted() {
        if (this.status) {
            this.formInline.status = Number(this.status)
        }
        this.getDicList();
        this.getBuildList();
    },
    methods: {
        getBuildList() {
            this.loading = true;
            getMetaCommonList('wisdom_park.wp_building', {
                size: 100,
                current: 1,
            }).then(res => {
                this.loading = false;
                const data = res.data.data;
                this.buildList = data.records;
            });
        },
        getFloors() {
            let obj = {
                size: 1000,
                current: 1,
                orders: [{ field: 'code+1000', sort: 'DESC' }],
            };
            obj.wheres = [{ field: 'building_id', value: this.formInline.building_id }];
            getMetaCommonList('wisdom_park.wp_floor', obj).then(res => {
                const data = res.data.data;
                this.floorLists = data.records;
            });
        },
        refreshChange() {
            console.log('herer');
            this.onLoad(this.page);
        },
        close() {
            this.detailDia = false;
            this.onLoad();
        },
        back() {
            history.go(-1);
        },
        getDicList() {

            dictbizService
                .getDictionary({
                    code: 'RoomStatus',
                })
                .then(res => {
                    this.roomStatuss = (res.data.data || []).map(item => {
                        return {
                            name: item['dictValue'],
                            value: Number(item['dictKey']),
                            id: item['id'],
                        };
                    });
                });
        },
        saveSplitRoom() {
            this.$refs.saveSplitRoom.saveRooms();
        },

        editRoom() {
            this.onlyRead = !this.onlyRead;
            if (!this.onlyRead) {
                this.roomTitle = '房间编辑';
            } else {
                this.roomTitle = '房间详情';
            }
        },
        btbDO(type, index) {
            if (type == 'rowDel') {
                this.rowDel(index);
            }
            if (type == 'splitRoom') {
                this.splitRoom(index);
            }
        },
        cancle(room) {

            this.$confirm(`是否作废此房间${room.son_num > 0 ? '及其子房间？' : '？'}`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {


                updateRoomStatus(room.id).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!',
                        });
                        this.onLoad(this.page);
                    }
                })
            });
        },

        handleInternetShow(room) {
            this.$confirm(`${room.internet_show_flag == '0' ? '确定要展示此房间？' : '确定要关闭此房间？'}`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let flag = room.internet_show_flag == '0' ? '1' : '0'
                let t = { id: room.id, internet_show_flag: flag }
                let body = {
                    update: t,
                    primaryKeyValue: room.id,
                    primaryKey: "id",
                };
                updateMetaCommon(this.model, body).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!',
                        });
                        this.onLoad(this.page);
                    }
                })
            });
        },


        //
        onFloorLoad(id) {
            let params = {
                wheres: [
                    {
                        field: 'floor_id',
                        value: id,
                    },
                ],
            };
            getMetaCommonList('wisdom_park.v_wp_floor_stat', {
                current: 1,
                size: 500,
                ...params,
            }).then(res => {
                const data = res.data.data;
                this.sumCheckinArea = data.records[0].sum_free_area;
            });
        },

        getDetail(room, onlyRead) {
            this.ruleForm = {};

            this.ruleForm = JSON.parse(JSON.stringify(room));
            this.ruleForm.room_id = this.ruleForm.id
            this.roomTitle = '房间详情';
            this.onlyRead = onlyRead;
            this.onFloorLoad(room.floor_id);
            this.findFloors(room.building_id);
            this.dialogVisible = true;
        },

        closeDias() {
            this.dialogVisible = false;
            this.buildRead = false;
            this.ruleForm = {};
        },
        findFloors(bid) {
            let obj = {
                current: 1,
                size: 1000,
            };
            obj.wheres = [{ field: 'building_id', value: bid }];
            obj.orders = [{ field: 'code+1000', sort: 'DESC' }];
            getMetaCommonList(this.floorModel, obj).then(res => {
                const data = res.data.data;
                console.log(this.floors);
                this.floors = data.records;
            });
        },
        onLoad() {
            let obj = this.getSearch()
            this.getMetaCommonList(obj);
        },
        search() {
            this.page.currentPage = 1
            let obj = this.getSearch();
            console.log(obj);
            this.getMetaCommonList(obj);
        },
        getMetaCommonList(obj) {
            this.btnLoding = true;
            getMetaCommonList(this.view_model, obj).then(res => {
                const data = res.data.data;
                this.page.total = data.total;
                this.data = data.records;
                this.btnLoding = false;
            });
        },
        getSearch() {
            let wheres = [];
            for (let key in this.formInline) {
                if (key == 'name') {
                    wheres.push({
                        field: 'name',
                        value: this.formInline[key],
                        op: 'LIKE',
                    });
                } else {
                    wheres.push({
                        field: key,
                        value: this.formInline[key],
                    });
                }
            }
            return {
                current: this.page.currentPage,
                size: this.page.pageSize,
                wheres: wheres,
            };
        },

        getMetaCommonListExport() {
            this.downLoading = true;
            let obj = this.getSearch();
            getMetaCommonListExport(this.view_model, obj)
                .then(res => {
                    this.downLoading = false;
                    let url = window.URL.createObjectURL(new Blob([res.data]));
                    let link = document.createElement('a');
                    link.style.display = 'none';
                    link.href = url;
                    link.download = '房屋详情' + '.xls';
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(e => {
                    this.downLoading = false;
                });
        },
        async getroomCommonList(obj) {
            getMetaCommonList(this.view_model, obj).then(res => {
                const data = res.data.data;
                this.page.total = data.total;
                this.data = data.records;
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.titleclazz {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.configInput {
    position: relative;
    font-size: 14px;
    display: inline-block;
    margin: 0px 5px;
}

.card {
    padding: 0px 10px 10px 0px;
}

ul,
li {
    list-style: none;
    margin-bottom: 5px;
}

.spaceCard {
    display: inline-block;
    min-width: 100px;
    height: 105px;
}

.cardBg {
    background: #f5f7fa;
}

.spaceCard {
    &:hover {
        .addbtn {
            display: block;
        }
    }
}

.addbtn {
    border: 1px dotted #1976d3;
    padding: 5px 10px;
    color: #1976d3;
    margin-bottom: 10px;
    border-radius: 0px;
}

.roomClazz {
    white-space: nowrap;
    font-size: 0px;
    overflow-x: auto;
    width: 100%;
}

/deep/ .el-dialog__header {
    border-bottom: 1px solid #ebebeb;
    padding-bottom: 20px;
}

.b-b {
    border-bottom: 1px solid #dcdfe6;
}

.dropclazz {
    position: absolute;
    right: 5px;
    top: 5px;
    padding: 3px 5px 3px 0px;
    transform: rotate(-90deg);
}

.p-r {
    position: relative;
}

/deep/ .el-drawer__header {
    border-bottom: 1px solid #ebebeb;
    padding: 10px 20px;
    margin-bottom: 0px;
}

/deep/ .el-drawer__body {
    padding: 0px;
}

/deep/.el-dialog__body {
    height: calc(80vh - 110px);
    overflow: auto;
    padding: 15px;
}

/deep/.ttt .el-dialog__body {
    height: auto;
    overflow: auto;
    padding: 15px;
}

.cz-pos {
    position: absolute;
    top: 10px;
    right: 20px;
    opacity: 0.3;
}

.room-search {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
}

.room-search span {
    display: inline-block;
    width: 80px;
    flex-shrink: 0;
}

.room-search div {
    flex: 1;
}
</style>
